export const PointExchangeType = {
  GIFT_CARDS: "gift_cards",
  CASH: "cash",
  PHYSICAL_PRODUCTS: "physical_products",
  TRAVEL: "travel",
  FOOD: "food",
  UTILITIES: "utilities",
  OTHER: "other",
};
